module.exports = "/_next/static/images/SergheiBusmachi-59a70c8fd847cf25815b177dd7768c47.webp";